import { proxy } from 'valtio';

class Store {
  isSessionExpired: boolean = false;

  expire() {
    if (this.isSessionExpired) {
      return;
    }
    this.isSessionExpired = true;
  }

  reset() {
    this.isSessionExpired = false;
  }
}

const sessionStore = proxy(new Store());
export default sessionStore;
